module.exports = __webpack_public_path__ + "static/media/burger.e1d9c505.svg";